import { getPrivacyPolicyUrl, getTermsOfServiceUrl } from "src/pages/constants";
import { useMemberInfoState } from "src/recoil/member/hook";
import getAppInfo from "src/utils/app-Info";

// 자주묻는질문 링크
export const FREQUENTLY_ASKED_QUESTIONS = "https://courtguide.notion.site/Taap_FAQ-e34841a672d7478d918c2114cd4b99b5";
const BottomLinkList = () => {
  const { member } = useMemberInfoState();

  // PS-1788: 이용약관/개인정보처리방침 메뉴는 STPM 에서만 노출
  const isPolicyMenuVisible = getAppInfo().appType === "STPM";

  return (
    <>
      <article className={`before-login-list${isPolicyMenuVisible ? " bottom-divider" : ""}`}>
        <ul>
          <li className="icon icon-notice">
            <a href="/front/space/notices">공지사항</a>
          </li>
          {/* <li className="icon icon-notice">
          <Link to="/court/mypage/main">마이페이지</Link>
        </li> */}
          {/* <li className="icon icon-product">
          <Link to="/court">상품 문의</Link>
        </li>*/}
          {/* <li className="icon icon-call">
          <Link
            to="#"
            onClick={(e: any) => {
              e.preventDefault();
              // window.open(FREQUENTLY_ASKED_QUESTIONS);
            }}
          >
            앱 사용문의
          </Link>
        </li>
        <li className="icon icon-call">
          <Link
            to="#"
            onClick={(e: any) => {
              e.preventDefault();
              window.open(FREQUENTLY_ASKED_QUESTIONS);
            }}
          >
            자주 묻는 질문
          </Link>
        </li>
        <li className="icon icon-call">
          <div className="flex-center-start">
            <p>회원번호</p>
          </div>
          <div className="flex-center-end ">
            <p>{member?.memberNo}</p>
          </div>
        </li> */}
        </ul>
      </article>

      {isPolicyMenuVisible && (
        <article className="before-login-list">
          <ul>
            <li className="icon icon-tos">
              <a href={getTermsOfServiceUrl()} target="_blank" rel="noreferrer noopener">
                이용약관
              </a>
            </li>
            <li className="icon icon-privacy">
              <a href={getPrivacyPolicyUrl()} target="_blank" rel="noreferrer noopener">
                개인정보처리방침
              </a>
            </li>
          </ul>
        </article>
      )}
    </>
  );
};

export default BottomLinkList;
